import React, { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import Navbar from "../../shared/components/navbar";
import Sidebar from "../../shared/components/sidebar";
import Button from "../../shared/components/button/button";
import {
  CheckoutParams,
  postCancelProductSubscription,
} from "../../store/checkout/api";
import {
  Invoices,
  Tenant,
} from "../../shared/interfaces/model/tenant.interface";
import { isCurrentDateEqualOrLessThanGivenDate } from "../../../utils/dateUtils";
import { Product } from "../../shared/interfaces/model/product.interface";
import apiClient from "../../store/shared/api/apiClient";
import { ErroObj } from "../../shared/interfaces/model/errorObj.interface";
import { ApiErrorHandler } from "../../../errorHandler";
import { getTenantDetail } from "../../store/tenant/api";
import MainLayout from "../../shared/components/MainLayout";
import { AnimatePresence, motion } from "framer-motion";
import Button2 from "../../shared/components/button/Button2";
import {
  ArrowBigLeft,
  ArrowBigRight,
  Building,
  CalendarClock,
  CodeIcon,
  CreditCard,
  CrossIcon,
  DoorClosed,
  DownloadCloud,
  Euro,
  File,
  FileArchive,
  FilePlus,
  FileText,
  Globe2,
  Globe2Icon,
  Mail,
  Package,
  Send,
  User,
  X,
} from "lucide-react";
import SuccessModal from "../multiDetailsTenant/components/SuccessModal";
import ErorrModal from "../multiDetailsTenant/components/ErorrModal";
import { useProductStatus } from "./hooks/useProductStatus";
import { getJWTDecoded } from "../../../utils/userUtils";
import Loader from "../../shared/components/loader/Loader";

const sendInvoiceRequest = async (invoiceData: any) => {
  const object = {
    invoiceRequest: true,
    productName: invoiceData.productName,
    receipt: invoiceData.receipt,
    userData: {
      email: invoiceData.userData.email,
      fiscalCode: invoiceData.userData.fiscalCode,
      lastName: invoiceData.userData.lastName,
      name: invoiceData.userData.name,
      pec: invoiceData.userData.pec,
      recipientCode: invoiceData.userData.recipientCode,
      vat: invoiceData.userData.vat,
      companyName: invoiceData.tenant.organizationName,
      denominazione: invoiceData.userData.denominazione,
    },
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/sendInvoiceEmail`;

  return apiClient
    .post(URL, object)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

// New helper components
const InfoItem = ({
  label,
  value,
  Icon,
  innerContent,
}: {
  label: string;
  value: any;
  Icon?: any;
  innerContent?: React.ReactNode;
}) => (
  <div className="space-y-1">
    <p className="text-sm text-[#] flex items-center flex-row text-md">
      {Icon && <Icon className="w-4 h-4 mr-2" />}
      {label}
    </p>
    <p className="text-gray-800 font-medium text-sm">{value}</p>
    {innerContent && innerContent}
  </div>
);

const StatusBadge = ({ status }: { status: string }) => (
  <span
    className={`
        inline-flex items-center px-3 py-1 rounded-full text-sm font-medium
        ${
          status === "Paid" || status === "Active"
            ? "bg-green-100 text-green-800"
            : "bg-red-100 text-red-800"
        }
    `}
  >
    {status}
  </span>
);

const DetailProduct: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const { product, paidProductInfo } = state || {};
  const [isCancelButton, setIsCancelButton] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productInformation, setProductInformation] = useState<any>(null);
  const [currentProduct, setCurrentProduct] = useState<any>(null);
  const tenantId = localStorage.getItem("tenantId");
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [errorMsgs, setErrorMsgs] = useState<string>("Generate invoice error");
  const [userData, setUserData] = useState({
    name: "",
    lastName: "",
    email: "",
    fiscalCode: "",
    vat: "",
    recipientCode: "",
    pec: "",
    denominazione: "",
  });
  const isUserSimple = localStorage.getItem("isUser") === "true";
  const [selectedInvoice, setSelectedInvoice] = useState<Invoices | null>(null);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const calculatetheStautsByExpireDateAndTier = (prod: any) => {
    const expDate = new Date(prod.expireDate?.split(" ")[0]);
    const isExpire = Boolean(expDate < new Date() && prod.tier);
    const isPaid = Boolean(
      !Number.isNaN(expDate.getTime()) && expDate > new Date()
    );
    const isCancelled = Boolean(prod.paymentStatus === "Cancelled");

    console.log("check status ------------>", {
      isExpire,
      isPaid,
      isCancelled,
    });
    if (isExpire) return "Expired";
    if (isPaid) return "Active";
    if (isCancelled) return "Cancelled";
    return "";
  };

  const getProductInfo = useCallback(async () => {
    if (paidProductInfo) {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const decodedToken = getJWTDecoded(token ?? "");
        const ten = await getTenantDetail(decodedToken.firebase?.tenant || "");

        const prod = ten.testProducts.find(
          (product: any) =>
            product.productAppCode === paidProductInfo.productAppCode
        );

        setProductInformation(ten);
        setCurrentProduct(prod);
        console.log("db prod info  =======>", prod);
        setPaymentStatus(calculatetheStautsByExpireDateAndTier(prod));
        if (prod && prod.paymentStatus === "Cancelled") {
          setIsCancelButton(false);
        } else {
          setIsCancelButton(true);
        }
      } catch (error) {
        console.log("error occur ====>", error);
      } finally {
        setLoading(false);
      }
    }
  }, [paidProductInfo]);

  useEffect(() => {
    getProductInfo();
  }, [getProductInfo]);

  useEffect(() => {
    if (paidProductInfo) {
      if (paidProductInfo.paymentStatus === "Paid") {
        setIsCancelButton(true);
      } else if (paidProductInfo.paymentStatus === "Cancelled") {
        setIsCancelButton(false);
      } else {
        setIsCancelButton(false);
      }
    }
  }, [paidProductInfo]);

  const handleCancelSubscription = () => {
    setIsModalOpen(true);
  };

  const handleConfirmCancellation = () => {
    const basePath = process.env.REACT_APP_ACTIVATION_URL;
    // console.log("close model ======>");
    const body: CheckoutParams = {
      tenantId: tenantId ?? "",
      productId: product.appCode,
      quantity: 1,
      // domain: 'https://nexum-saas-portal.oa.r.appspot.com/private/checkoutPage/',
      //domain: "http://localhost:3000/private/checkoutPage/",
      domain: `https://${basePath}/private/checkoutPage/`,
      subscription: "Monthly",
      tier: "Standard",
      subscriptionId: paidProductInfo.subscriptionId,
    };
    postCancelProductSubscription(body)
      .then((res: any) => {
        if (res.data.subscriptionEndOn) {
          navigate("/private/productlistv3");
        }
      })
      .catch((error) => {
        // console.log('Error:', error);
        setErrorModal(true);
      })
      .finally(() => {
        setIsModalOpen(false);
        setLoading(false);
      });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleOpenInvoiceModal = (item: Invoices) => {
    setSelectedInvoice(item);
    setInvoiceModalOpen(true);
  };

  const handleRequestInvoice = async () => {
    const { fiscalCode, vat, recipientCode, pec, email, denominazione } =
      userData;
    const hasRequiredFields = isUserSimple
      ? email && fiscalCode
      : email && vat && (recipientCode || pec);
    const tenant: Tenant = await getTenantDetail(tenantId || "");
    if (!hasRequiredFields) {
      setErrorModal(true);
      setErrorMsgs("Please fill all required fields");
      return;
    }
    // Invia la richiesta di fattura
    await sendInvoiceRequest({
      tenant,
      userData,
      productName: product.name,
      receipt: selectedInvoice?.invoicePdf,
      denominazione,
    });
    // alert("Richiesta di fattura inviata con successo.");
    setSelectedInvoice(null);
    setInvoiceModalOpen(false);
    setSuccessModal(true);
  };

  const downloadHandler = (pdfUrl: string) => {
    window.open(pdfUrl, "_blank");
    // console.log('Download handler');
  };

  const formateDate = (date: string) => {
    if (date) {
      const shortDate = date.split(" ")[0];
      if (shortDate) {
        const [year, month, day] = shortDate.split("-");
        return `${day}/${month}/${year}`;
      }
      return "";
    }
    return "";
  };
  const goToCheckout = () => {
    navigate(`/private/checkoutPage/${product.appCode}`, {
      state: { product, paidProductInfo },
    });
  };

  return (
    <MainLayout>
      <Loader isLoading={loading} />
      <div className="w-full px-10" data-test="productList">
        <section className=" py-8 w-full">
          <h1 className="text-3xl font-bold text-[#0c1d46] flex items-center flex-row">
            <FileText className="w-6 h-6 mr-2" />
            Product Details
          </h1>
        </section>
        {/* <div className="w-full md:w-10/12 ml-12 p-4 py-8 bg-white">
          {product && (
            <div>
              <div className="flex mb-6">
                <Button
                  title="Torna Indietro"
                  disabled={loading}
                  onClickHandler={() => window.history.back()}
                />
              </div>
              <h2 className="mb-4 ml-2 text-gray-800">
                <span className="font-semibold mr-3">Nome del prodotto:</span>{" "}
                {product.name}
              </h2>
              <h2 className="mb-4 ml-2 text-gray-800">
                <span className="font-semibold mr-3">URL dell'app:</span>
                {
                  isCurrentDateEqualOrLessThanGivenDate(
                    paidProductInfo.expireDate
                  ) ? (
                    <a
                      href={product.appUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sky font-bold"
                    >
                      Link dell'app
                    </a>
                  ) : (
                    ""
                  )
                  // (
                  //     <button onClick={goToCheckout} className="bg-light-blue text-white font-bold py-2 px-4 rounded">
                  //         Per accedere servizio paga ora
                  //     </button>
                  // )
                }
              </h2>
              <h2 className="mb-4 ml-2 text-gray-800">
                <span className="font-semibold mr-3">Prezzo dell'app:</span>{" "}
                {product.price}€ per articolo
              </h2>
              <h2 className="mb-4 ml-2 text-gray-800">
                <span className="font-semibold mr-3">Descrizione:</span>{" "}
                {product.desc}
              </h2>
              <h1 className="mb-4 ml-2 text-gray-800 font-bold">
                <span className="font-semibold mr-3">
                  {!isCancelButton
                    ? "Puoi accedere all'app fino al"
                    : "Prossima data di rinnovo"}
                  :
                </span>{" "}
                {formateDate(paidProductInfo.expireDate)}
              </h1>
              <h1 className="mb-4 ml-2 text-gray-800">
                <span className="font-semibold mr-6 ">
                  Stato del pagamento:
                </span>
                <button
                  className={`py-1 px-4 rounded text-white ${paidProductInfo.paymentStatus === "Paid" ? "bg-green-500 " : "bg-red-500"}`}
                  disabled
                >
                  {paidProductInfo.paymentStatus === "Paid"
                    ? "Pagato"
                    : "CANCELto"}
                </button>
              </h1>
              <h1 className="mb-6 ml-2 ">
                <span className="font-semibold">App Code:</span>{" "}
                {paidProductInfo.productAppCode}
              </h1>
            </div>
          )}
        </div> */}
        <div className="flex mb-6">
          <Button2
            icon={ArrowBigLeft}
            iconPosition="left"
            title={"Back"}
            className="bg-[#0c1d46] hover:bg-sky-500 text-white transition-all"
            disabled={loading}
            onClick={() => window.history.back()}
          />
        </div>
        {/* Product Info Card */}
        <motion.div
          className="px-5 py-8 bg-white rounded-xl shadow-lg"
          whileHover={{ scale: 1.01 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          {product && (
            <div className="space-y-6">
              {/* Product Details Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InfoItem
                  label="Product Name"
                  value={product.name}
                  Icon={Package}
                />
                <div>
                  <InfoItem
                    label={"Access valid until"}
                    Icon={CalendarClock}
                    innerContent={
                      <div className="mt-2 flex items-center flex-row">
                        <span className="mr-2">
                          {formateDate(currentProduct?.expireDate)}
                        </span>
                        <StatusBadge status={paymentStatus} />
                        {paymentStatus === "Expired" && (
                          <Button2
                            title="Renew Now"
                            className="bg-[#0c1d46] p-1  hover:bg-sky-500 text-white transition-all ml-3"
                            onClick={() => {
                              navigate(
                                `/private/productListV3/${product.appCode}`,
                                {
                                  state: { product, paidProductInfo },
                                }
                              );
                            }}
                          />
                        )}
                      </div>
                    }
                    value={""}
                  />
                </div>

                <InfoItem
                  label="Description"
                  Icon={FileText}
                  value={""}
                  innerContent={
                    <div className="text-gray-500 w-full text-sm">
                      {product.description}
                    </div>
                  }
                />
                <InfoItem
                  label="Amount"
                  Icon={Euro}
                  value={
                    paidProductInfo.payment === "Annually"
                      ? `${Number(paidProductInfo.price) * 12}€ per year`
                      : `${paidProductInfo.price}€ per month`
                  }
                />
                <InfoItem
                  label="App Code"
                  Icon={Package}
                  value={paidProductInfo.productAppCode}
                />
                {currentProduct && (
                  <InfoItem
                    label="App URL"
                    Icon={Globe2}
                    value={
                      isCurrentDateEqualOrLessThanGivenDate(
                        currentProduct?.expireDate
                      ) ? (
                        <a
                          href={`${product.baseUrl}?token=${localStorage.getItem("token")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-white p-2 w-[150px] px-5 text-center  mt-2 rounded bg-green-500 hover:bg-sky-500 font-medium flex items-center cursor-pointer transition-all"
                        >
                          Access App{" "}
                          <Globe2Icon className="ml-2 transform rotate-180" />
                        </a>
                      ) : (
                        ""
                      )
                    }
                  />
                )}
              </div>
            </div>
          )}
        </motion.div>

        {/* Receipts Section */}
        <motion.div
          className="w-full px-5 py-8 mt-6 bg-white rounded-xl shadow-lg mb-8"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="flex items-center mb-6">
            <FileText className="text-2xl mr-2 text-gray-700" />
            <h2 className="text-xl font-semibold">Receipts</h2>
          </div>

          {/* Receipt Items */}
          <div className="space-y-4">
            {paidProductInfo?.invoices?.map((item: Invoices) => (
              <motion.div
                key={item.invoiceId}
                className="border border-gray-200 p-4 rounded-lg hover:shadow-md transition-all "
                whileHover={{ scale: 1.01 }}
              >
                <p className="leading-10 flex items-center flex-wrap">
                  <span
                    className="font-semibold flex items-center flex-row"
                    style={{ margin: "0 10px" }}
                  >
                    <File className="w-4 h-4 mr-2" /> Receipt #:
                  </span>{" "}
                  <span className="text-green-500">{item.invoiceId}</span>
                </p>
                <Button2
                  title="Download"
                  icon={DownloadCloud}
                  className="bg-sky-500 hover:bg-sky-600 text-white transition-all mr-2 mb-2"
                  iconPosition="left"
                  onClick={() => downloadHandler(item.invoicePdf)}
                />
                <Button2
                  title="Generate Invoice"
                  icon={FileArchive}
                  className="bg-green-400 hover:bg-green-600 text-white transition-all mb-2"
                  iconPosition="left"
                  onClick={() => handleOpenInvoiceModal(item)}
                />
              </motion.div>
            ))}
          </div>

          {/* Cancel Subscription Button */}
          {isCancelButton && (
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleCancelSubscription}
              disabled={loading}
              className="mt-6 bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-6 rounded-lg flex items-center"
            >
              <DoorClosed className="mr-2" />
              Cancel Subscription
            </motion.button>
          )}
        </motion.div>
      </div>
      {isModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-50">
          {loading && (
            <div role="status">
              <svg
                aria-hidden="true"
                className="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          )}
          <div className="bg-white p-6 rounded-md shadow-md">
            <h2 className="text-lg font-semibold mb-4">Confirm Cancellation</h2>
            <p>Are you sure you want to cancel your subscription?</p>
            <div className="flex justify-end mt-4">
              <button
                onClick={handleCloseModal}
                className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 mr-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmCancellation}
                disabled={loading}
                className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {invoiceModalOpen && (
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
          >
            <motion.div
              initial={{ scale: 0.9, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 20 }}
              className="bg-white w-full max-w-2xl rounded-lg shadow-xl overflow-hidden"
            >
              <div className="flex justify-between items-center p-6 bg-sky-50 border-b">
                <h2 className="text-2xl font-semibold text-gray-800 flex items-center">
                  <FilePlus className="mr-2" /> Require Invoice
                </h2>
                <button
                  onClick={() => setInvoiceModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700 transition-colors"
                >
                  <X size={24} />
                </button>
              </div>
              <form className="p-6 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Name*
                    </label>
                    <div className="relative">
                      <User
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                        size={18}
                      />
                      <input
                        type="text"
                        name="name"
                        value={userData.name}
                        onChange={(e) =>
                          setUserData({ ...userData, name: e.target.value })
                        }
                        className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Lastname*
                    </label>
                    <div className="relative">
                      <User
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                        size={18}
                      />
                      <input
                        type="text"
                        name="lastName"
                        value={userData.lastName}
                        onChange={(e) =>
                          setUserData({ ...userData, lastName: e.target.value })
                        }
                        className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email*
                  </label>
                  <div className="relative">
                    <Mail
                      className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                      size={18}
                    />
                    <input
                      type="email"
                      name="email"
                      value={userData.email}
                      onChange={(e) =>
                        setUserData({ ...userData, email: e.target.value })
                      }
                      className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Denominazione*
                  </label>
                  <div className="relative">
                    <Building
                      className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                      size={18}
                    />
                    <input
                      type="text"
                      name="denominazione"
                      value={userData.denominazione}
                      onChange={(e) =>
                        setUserData({
                          ...userData,
                          denominazione: e.target.value,
                        })
                      }
                      className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                </div>
                {isUserSimple ? (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Fiscal Code*
                    </label>
                    <div className="relative">
                      <CreditCard
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                        size={18}
                      />
                      <input
                        type="text"
                        name="fiscalCode"
                        value={userData.fiscalCode}
                        onChange={(e) =>
                          setUserData({
                            ...userData,
                            fiscalCode: e.target.value,
                          })
                        }
                        className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        VAT / Tax number*
                      </label>
                      <div className="relative">
                        <CreditCard
                          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                          size={18}
                        />
                        <input
                          type="text"
                          name="vat"
                          value={userData.vat}
                          onChange={(e) =>
                            setUserData({ ...userData, vat: e.target.value })
                          }
                          className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Destination Code*
                      </label>
                      <div className="relative">
                        <FileText
                          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                          size={18}
                        />
                        <input
                          type="text"
                          name="recipientCode"
                          value={userData.recipientCode}
                          onChange={(e) =>
                            setUserData({
                              ...userData,
                              recipientCode: e.target.value,
                            })
                          }
                          className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        PEC*
                      </label>
                      <div className="relative">
                        <Mail
                          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                          size={18}
                        />
                        <input
                          type="text"
                          name="pec"
                          value={userData.pec}
                          onChange={(e) =>
                            setUserData({ ...userData, pec: e.target.value })
                          }
                          className="pl-10 w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                  </>
                )}
              </form>
              <div className="flex justify-end space-x-4 p-6 bg-gray-50 border-t">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setInvoiceModalOpen(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => handleRequestInvoice()}
                  className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors flex items-center"
                >
                  <Send className="mr-2" size={18} /> Require Invoice
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      )}

      {/* Success Modal */}
      <SuccessModal
        show={successModal}
        setShow={setSuccessModal}
        description="Richiesta di fattura inviata con successo."
      />

      {/* Error Modal */}
      <ErorrModal
        show={errorModal}
        setShow={setErrorModal}
        emailError={errorMsgs}
      />

      {/* {invoiceModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded-md shadow-md w-1/2">
                                <h2 className="text-lg font-semibold mb-4">Require Invoice</h2>
                                <form>
                 
                                    <div className="mb-4">
                                        <label className="block text-gray-700">Name</label>
                                        <input type="text" value={userData.name} onChange={(e) => setUserData({ ...userData, name: e.target.value })} className="border rounded w-full p-2" />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700">Lastname</label>
                                        <input type="text" value={userData.lastName} onChange={(e) => setUserData({ ...userData, lastName: e.target.value })} className="border rounded w-full p-2" />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700">Email</label>
                                        <input type="email" value={userData.email} onChange={(e) => setUserData({ ...userData, email: e.target.value })} className="border rounded w-full p-2" />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700">Denominazione</label>
                                        <input type="text" value={userData.denominazione} onChange={(e) => setUserData({ ...userData, denominazione: e.target.value })} className="border rounded w-full p-2" />
                                    </div>

     
                                    {isUserSimple ? (
                                        <div className="mb-4">
                                            <label className="block text-gray-700">Fiscal Code</label>
                                            <input type="text" value={userData.fiscalCode} onChange={(e) => setUserData({ ...userData, fiscalCode: e.target.value })} className="border rounded w-full p-2" />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="mb-4">
                                                <label className="block text-gray-700">VAT / Tax number</label>
                                                <input type="text" value={userData.vat} onChange={(e) => setUserData({ ...userData, vat: e.target.value })} className="border rounded w-full p-2" />
                                            </div>
                                            <div className="mb-4">
                                                <label className="block text-gray-700">Destination Code</label>
                                                <input type="text" value={userData.recipientCode} onChange={(e) => setUserData({ ...userData, recipientCode: e.target.value })} className="border rounded w-full p-2" />
                                            </div>
                                            <div className="mb-4">
                                                <label className="block text-gray-700">PEC</label>
                                                <input type="text" value={userData.pec} onChange={(e) => setUserData({ ...userData, pec: e.target.value })} className="border rounded w-full p-2" />
                                            </div>
                                        </>
                                    )}
                                </form>
                                <div className="flex justify-start mt-4">
                                    <button
                                        onClick={handleRequestInvoice}
                                        className="bg-gray-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded"
                                    >
                                        Require Invoice
                                    </button>
                                    <button
                                        onClick={() => setInvoiceModalOpen(false)}
                                        className="bg-gray-500 hover:bg-red-600 text-white font-bold py-2 px-4 ml-auto rounded"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>

                        </div>

      )} */}
    </MainLayout>
  );
};

export default DetailProduct;
